import {assert} from 'assert-ts';
import type {RegexCondition} from 'schemaDefinition/types';
import {logError} from 'logging';
import type {EvaluationArgs} from './types';
import {evaluateValWithDefault} from './evaluateValWithDefault';

const regexpCache: {[key: string]: RegExp} = {};

export const evaluateRegexCondition = (
  condition: RegexCondition,
  args: EvaluationArgs,
): boolean => {
  const value = evaluateValWithDefault(condition.arg, args, args.value);

  if (value === undefined || value === null) {
    return condition.default;
  }

  const strValue = typeof value === 'string' ? value : JSON.stringify(value);

  if (value === '') {
    return condition.default;
  }

  const regexps = Array.isArray(condition.regex)
    ? condition.regex
    : [condition.regex];
  return regexps.reduce<boolean>((acc, re) => {
    if (acc) {
      return acc;
    }
    const cached = regexpCache[re];
    const regex = cached ?? makeRegex(re);
    if (!cached && regex) {
      regexpCache[re] = regex;
    }

    if (!regex) {
      assert.soft(false, 'evaluateRegexCondition: invalid regex', {re});
      return true;
    }

    return regex.test(strValue);
  }, false);
};

const makeRegex = (regexStr: string): RegExp | undefined => {
  try {
    return new RegExp(regexStr, 'i');
  } catch {
    logError(`RegexCondition: invalid: ${regexStr}`);
    return undefined;
  }
};
